import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.26);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`

  display: flex;
  width: 312px;
  padding: 38px 24px 24px 24px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
  border-radius: 16px;
  background: #161717;
  /* Microsoft Edge */
  -ms-overflow-style: none;
  scrollbar-width: none;

  /*Chrome*/

  ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: transparent;
  }


`

export const Heading = styled.p`

  color: #E9E9F0;
  text-align: center;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.408px;
  text-decoration-line: underline;

  `
export const Text = styled.p`
    margin-top: 2rem;
  width: 264px;
  color: #E9E9F0;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 100% */
`
export const Button = styled.button`
  background: transparent;
  display: flex;
  width: 212px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  /* M3/body/large */
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.5px;
  border-radius: 8px;
  border: 1px solid #FFC000;
  color: #FFC000;

  /* M3/body/large */
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.5px;

`

